const messages = {
  logoutLabel: 'Logout',
  sanityDesc: 'Are you sure you want to log out? To enter again it will be necessary that you provide us with your access credentials.',
  cancelLogout: 'Cancel',
  confirmLogout: 'Confirm'
}

export default messages
